<template>
  <q-page>
    <DocumentTabPanel />
  </q-page>
</template>

<script>
// @ is an alias to /src
import DocumentTabPanel from "@/components/DocumentTabPanel.vue";

export default {
  setup() {
    return {};
  },
  name: "Doc",
  components: { DocumentTabPanel }
};
</script>
